import React from 'react';
import PropTypes from 'prop-types';

const AsFeaturedIn = ({content: quote, onClickEvent}) => {
  const{citation, img, text, platform} = quote;

  return <a className={'quote'} href={citation} data-label={platform} onClick={onClickEvent} data-section='AsFeaturedIn'>
    <img src={img} alt="logo" className="logo"/>
    <div className="text">&quot;{text}&quot;</div>
  </a>
};

AsFeaturedIn.propTypes = {
  content:PropTypes.object,
  onClickEvent: PropTypes.func
};

export default AsFeaturedIn;